import { Icon } from './Icon';

/**
 * مدى التاريخ في شريط القائمة — «من تاريخ» و«إلى تاريخ».
 *
 * غيرُ `PeriodNav`: ذاك حبيباتٌ (أسبوع/شهر/سنة) لتقارير تُقرأ بفترة، وهذا
 * حقلان مستقلّان لقائمة مستندات — طرفٌ وحده يحدّ: «من أوّل الشهر» بلا
 * نهاية سؤالٌ معقول. واليومُ الأخير داخلٌ كلّه، والخادمُ يحسبه كذلك.
 *
 * القيمُ نصوصُ `yyyy-mm-dd` كما في الرابط، والفارغُ `undefined` فيُمحى منه.
 */
export function DateRangeFilter({
  from,
  to,
  onChange,
}: {
  from?: string;
  to?: string;
  onChange: (from: string | undefined, to: string | undefined) => void;
}) {
  return (
    <span className="row" style={{ gap: 8 }}>
      <input
        className="input"
        type="date"
        value={from ?? ''}
        max={to || undefined}
        aria-label="من تاريخ"
        title="من تاريخ"
        onChange={(e) => onChange(e.target.value || undefined, to)}
      />
      <input
        className="input"
        type="date"
        value={to ?? ''}
        min={from || undefined}
        aria-label="إلى تاريخ"
        title="إلى تاريخ"
        onChange={(e) => onChange(from, e.target.value || undefined)}
      />
      {(from || to) && (
        <button
          type="button"
          className="btn btn-sm btn-icon btn-ghost"
          aria-label="مسح مدى التاريخ"
          title="مسح مدى التاريخ"
          onClick={() => onChange(undefined, undefined)}
        >
          <Icon name="x" size={14} />
        </button>
      )}
    </span>
  );
}
